<template>
  <div class="all-wrapper menu-side with-pattern">
   <div class="auth-box-w wider">
      <div class="logo-w"><img alt="" src="../../assets/img/onetap_transparent.png" height="90"></div>
      <h4 class="auth-header">Welcome back!</h4>
      <form @submit="login">
        <div class="alert alert-danger" role="alert" v-if="errors.length" v-for="error in errors">
          {{ error }}
        </div>
         <div class="form-group">
            <label for=""> Email address</label><input class="form-control" placeholder="Enter email address" type="email" v-model="email">
            <div class="pre-icon os-icon os-icon-email-2-at2"></div>
         </div>
         <div class="form-group">
            <label for=""> Password</label><input class="form-control" placeholder="Enter password" type="password" v-model="password">
            <div class="pre-icon os-icon os-icon-fingerprint"></div>
         </div>
         <div class="buttons-w"><button class="btn btn-primary">Login</button><router-link class="btn btn-link" to="/auth/forgot">Forgot password?</router-link><router-link class="btn btn-link" to="/auth/register">Register</router-link><router-link :to="{ name: '', params: {} }"></router-link></div>
      </form>
   </div>
 </div>
</template>

<script>
export default {
  name: 'Login',
  metaInfo: {
    title: 'login',
    titleTemplate: 'onetap | %s',
    meta: [
      { property: 'og:title', content: 'onetap | Register' },
      { property: 'og:site_name', content: 'onetap' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://onetap.gg/'},
      { property: 'og:description', content: 'Providing public & private CS:GO servers' },
      { itemprop: 'name', content: 'onetap | Register' },
      { itemprop: 'description', content: 'Providing public & private CS:GO servers'},
    ]
  },
  data() {
    return {
      jwt: this.$root.authToken,
      registerBg: [
        require('../../assets/img/de_dust2.jpg'),
      ],
      max: 13,
      image: null,
      errors: [],
      email: null,
      password: null
    }
  },
  methods: {
    login: function(e) {
      e.preventDefault()
      this.errors = [];

      if (!this.email) {
        this.errors.push('Email is required!');
        return;
      } else if (!this.validEmail(this.email)) {
        this.errors.push(`Are you sure that's the correct email?`);
      }

      if (!this.password) {
        this.errors.push('Password is required!');
        return;
      }

      this.errors.push('Logging in. Please wait.');

      this.axios.post(`${this.API_URL}/auth/login`, { email: this.email, password: this.password }).then((res) => {
        if (res.data.message === 'Require verify.') {
          this.$root.authToken = res.data.authToken;
          this.$router.push('/verify');
        } else {
          this.$root.authToken = res.data.token;
          this.$root.authTicket = null;
          this.$router.push('/');
        }
      }).catch((err) => {
        this.errors = [];
        this.errors.push(err.response.data.message);
      });
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },
  mounted() {
    //
  },
  created() {
    if (this.$root.isAuthenticated) {
      this.$router.push('/');
    }
    let random = Math.floor(Math.random() * this.registerBg.length);
    this.image = this.registerBg[random];
    window.$('body').removeClass('before-body menu-position-side menu-side-left full-screen with-content-panel');
    window.$('body').css('background-image', 'url("' + this.image + '")');
    window.$('body').css('background-size', 'cover');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
